module.exports = __webpack_public_path__ + "img/1_023.5a04f0d3.jpg";